export default function stubTrue() {
  return true
}
